module.exports = __webpack_public_path__ + "static/media/2.22c72654.svg";